import { render, staticRenderFns } from "./AtendimentoFormulario.vue?vue&type=template&id=071ef586&scoped=true"
import script from "./AtendimentoFormulario.vue?vue&type=script&lang=js"
export * from "./AtendimentoFormulario.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoFormulario.vue?vue&type=style&index=0&id=071ef586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071ef586",
  null
  
)

export default component.exports